<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <ListPanel v-else :users="users" :portal="portal"/>
  </div>
</template>

<script>
import http from '@/http'
import ListPanel from '../../../../../../../components/Administration/ContentEvents/Panels/List'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {ListPanel, LoadingContainer},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      users: null,

      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/users').then(response => {
        this.users = response.data.data

        this.loading = false
      })
    },
  }
}
</script>
